/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2022-04-12 18:26:02
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  loading: boolean,
  handleCancel: () => void,
  handleSwitchVersion: () => void
};

type ComposedProps = Props & WithI18nProps;
// DONE
class ConfirmSwitchVersionModal extends Component<ComposedProps> {
  render() {
    const { active, loading, i18n } = this.props;
    return (
      <Modal
        open={active}
        onClose={this.handleCancel}
        title={i18n.translate(
          'AdminHTML.MerchandisingV2.Merchandising.confirmSwitchVersionModal_Title'
        )}
        primaryAction={{
          content: i18n.translate('AdminHTML.Common.Action.switch'),
          loading: loading,
          onAction: this.handleSwitchVersion
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleCancel
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <p>
              {i18n.translate(
                'AdminHTML.MerchandisingV2.Merchandising.confirmSwitchVersionModal_Content01'
              )}
            </p>
            <p>
              {i18n.translate(
                'AdminHTML.MerchandisingV2.Merchandising.confirmSwitchVersionModal_Content02'
              )}
            </p>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleCancel = () => {
    this.props.handleCancel();
  };

  handleSwitchVersion = () => {
    this.props.handleSwitchVersion();
  };
}

export default withI18n()(ConfirmSwitchVersionModal);
